<script>
  import { Line } from 'vue-chartjs'
  import monthRangeFromBegin from '@/utils/monthRangeFromBegin'
  export default {
    extends: Line,
    props: ['customerStats'],
    data () {
      return {
        gradient_vof: null,
        gradient_ram: null,
        gradient_all: null,
        chartSeriesAll: [],
      }
    },
    mounted () {
      this.loadDataSeries()
    },
    methods: {
      async loadDataSeries () {
        this.chartSeriesAll = this.customerStats.allDomainCountByMonth
        this.loadChart()
      },
      loadChart () {
        this.gradient_vof = this.$refs.canvas
          .getContext('2d')
          .createLinearGradient(0, 0, 0, 450)
        this.gradient_ram = this.$refs.canvas
          .getContext('2d')
          .createLinearGradient(0, 0, 0, 450)
        this.gradient_all = this.$refs.canvas
          .getContext('2d')
          .createLinearGradient(0, 0, 0, 450)

        this.gradient_vof.addColorStop(0, 'rgba(0, 202, 227, 0.5)')
        this.gradient_vof.addColorStop(0.5, 'rgba(0, 202, 227, 0.25)')
        this.gradient_vof.addColorStop(1, 'rgba(0, 202, 227, 0)')

        this.gradient_ram.addColorStop(0, 'rgba(204, 0, 0, 0.9)')
        this.gradient_ram.addColorStop(0.5, 'rgba(204, 0, 0, 0.25)')
        this.gradient_ram.addColorStop(1, 'rgba(204, 0, 0, 0)')

        this.gradient_all.addColorStop(0, 'rgba(76, 175, 80, 0.9)')
        this.gradient_all.addColorStop(0.5, 'rgba(76, 175, 80, 0.25)')
        this.gradient_all.addColorStop(1, 'rgba(76, 175, 80, 0)')

        this.renderChart(
          {
            labels: monthRangeFromBegin(),
            datasets: [
              {
                label: 'Alle',
                borderColor: 'chocolate',
                pointBackgroundColor: 'white',
                pointBorderColor: 'chocolate',
                borderWidth: 3,
                backgroundColor: 'transparent',
                data: this.chartSeriesAll,
              },
            ],
          },
          { responsive: true, maintainAspectRatio: false },
        )
      },
    },
  }
</script>
